<template>
  <transition name="o-transition__modal">
    <CallCenterAEDModal
      v-if="showModal"
      @close="closeModal"
      class="c-admin-manufacturerDelete"
    >
      <h2
        class="o-heading o-heading--size-2 o-heading--section o-heading--border"
        slot="header"
      >
        {{ translationsManufacturersModal.deleteHeadline }} "{{
          mutableObject.name
        }}"
      </h2>
      <div slot="body">
        <div
          class="c-admin-manufacturerDelete__inputs-wrap o-grid o-grid--gutter-normal o-grid--padding-none o-grid--align-items-center"
        >
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <h4
                class="c-modal-comment__text-label o-heading o-heading--size-4 o-label o-label--block"
              >
                {{ translationsManufacturersModal.deleteText || "" }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="o-grid o-grid--gutter-small">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--grow-0">
              <button class="o-button" @click.self="deleteItem">
                {{ translationsManufacturersTable.deleteManufacturer }}
              </button>
            </div>
            <div class="o-grid__item o-grid__item--grow-0">
              <button
                class="o-button o-button--transparent"
                @click.self="closeModal()"
              >
                {{ translationsCustom.cancel || "" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CallCenterAEDModal>
  </transition>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      name: "Angiv status",
      showModal: false,
      mutableObject: {
        id: 0, // BE needs it to be 0 and not NULL
        name: ""
      }
    };
  },
  props: {
    manufacturer: { type: Object, required: false },
    showManufacturerDelete: { type: Boolean, required: true }
  },
  computed: {
    ...mapState("manufacturers", ["selectableOptions"]),
    ...mapState("translations", {
      translationsManufacturersModal: "manufacturersModal",
      translationsManufacturersTable: "manufacturersTable",
      translationsCustom: "custom"
    })
  },
  methods: {
    ...mapActions("manufacturers", ["deleteManufacturer"]),
    closeModal() {
      this.mutableObject = {
        id: 0, // BE needs it to be 0 and not NULL
        name: ""
      };
      this.showModal = false;
      this.$emit("close");
    },
    deleteItem() {
      this.deleteManufacturer(this.mutableObject);
      this.closeModal();
    }
  },
  watch: {
    showManufacturerDelete(newValue) {
      this.showModal = newValue;
    }
  },
  created() {
    this.$nextTick(() => {
      this.showModal = this.showManufacturerDelete;
    });
  },
  mounted() {
    this.$store.subscribe(mutation => {
      if (mutation.type === "manufacturers/setDeleteManufacturer") {
        this.mutableObject = JSON.parse(JSON.stringify(mutation.payload));
        this.showModal = true;
      }
    });
  }
};
</script>

<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-admin-manufacturerDelete {
}
</style>
